import Glide from '@glidejs/glide';

const Slider = () => {
	// This allows for multiple flex content sliders on one page.
	const glide = document.querySelectorAll('.js-flex-content-glide');
	const config = {
		type: 'carousel',
		startAt: 0,
		perView: 1,
	};
	if (glide) glide.forEach((item) => new Glide(item, config).mount());

	// new Glide('.js-flex-content-glide').mount();

	// Add new sliders below with a different class.
	// new Glide('.classname').mount();
};

export default Slider;
